export default function () {
  /* 表格列头：统一 min-width，剩余宽度按内容长度比例分配，整行铺满不右侧留白 */
  return [
    { label: "序号", type: "index", width: 70 },
    { label: "店铺", prop: "store_name", slots: "store", minWidth: 220 },
    { label: "会员卡类型", prop: "type", slots: "type", minWidth: 110 },
    { label: "会员卡号", prop: "vip_number", slots: "vipNumber", minWidth: 140 },
    { label: "会员手机号", prop: "user_phone", slots: "userPhone", minWidth: 120 },
    { label: "核销人", prop: "cancel_phone", slots: "cancel", minWidth: 150 },
    { label: "金额", prop: "amount", slots: "amount", minWidth: 110 },
    { label: "余额", prop: "balance", slots: "balance", minWidth: 110 },
    { label: "交易描述", prop: "message", slots: "message", minWidth: 200 },
    { label: "交易时间", prop: "create_time", slots: "createTime", minWidth: 170 },
    {
      label: "操作",
      prop: "operation",
      minWidth: 100,
      slots: "operation",
    },
  ];
}
